<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout
    row
    wrap
    justify-center
    align-center
  >
    <v-flex
      layout
      row
      reverse
      wrap
      sm12
      px-5
      justify-space-around
    >
      <v-flex
        sm12
        md6
        align-center
        justify-center
        style="flex-basis: 500px;"
        mb-4
      >
        <v-card
          class="elevation-12 mx-auto login"
          style="max-width: 500px;"
          @keyup.native.enter="login"
        >
          <v-toolbar
            dark
            color="primary"
          >
            <v-toolbar-title>
              {{ $t('message.login_form_title') }}
            </v-toolbar-title>
            <v-spacer />
            <img src="cow.svg">
          </v-toolbar>
          <v-card-text>
            <v-text-field
              v-model="email"
              prepend-icon="fa-user"
              name="login"
              :label="$t('message.email')"
              type="text"
            />
            <v-text-field
              id="password"
              v-model="password"
              prepend-icon="fa-unlock-alt"
              name="password"
              :label="$t('message.password')"
              type="password"
            />
          </v-card-text>
          <v-card-actions>
            <a
              style="margin-left: 10px; font-size: 1.2rem;"
              @click="showForgotPasswordDialog = true"
            >{{ $t('message.forgot_password') }}</a>
            <v-spacer />
            <v-btn
              color="primary"
              @click="login"
            >
              {{ $t('message.login_button') }}
            </v-btn>
          </v-card-actions>
          <forgot-password-dialog
            v-model="showForgotPasswordDialog"
            @submit="sendForgotPasswordMail"
          />
        </v-card>
      </v-flex>
      <v-flex
        sm12
        md6
        grow
        style="max-width: none;"
        class="intro-text pr-5 mb-5"
      >
        <div class="title1">
          {{ $t('message.site_title1') }}
        </div>
        <p>
          Welkom op het platform <i>Geef ze de Vijf!</i>, het platform waar
          melkveehouders, erfbetreders en onderzoekers met elkaar discussiëren
          en kennis en ervaring uitwisselen over de levensduur van melkvee. Met
          als uitdaging een levensduur van 5 lactaties, gepaard aan betere
          economische resultaten.
        </p>
        Je kunt op verschillende niveaus aan het platform deelnemen:
        <br>
      </v-flex>
    </v-flex>

    <v-layout
      row
      wrap
      justify-space-around
      px-5
      :class="{ 'initial-flex': isInitialFlex }"
    >
      <v-flex
        sm6
        lg3
        class="registration-info"
      >
        <v-card>
          <v-card-title primary-title>
            <img src="/platform_icon.svg">
            <div class="headline">
              Kennis- en informatieplatform<br>Levensduurverlenging Melkvee
            </div>
          </v-card-title>
          <v-card-text class="grow">
            <p>
              De handleiding Duurzaam Melkvee Management uit 2013 vormde de basis
              voor het informatieplatform Geef ze de vijf! over levensduurverlenging
              bij melkvee. Naar aanleiding van de ervaringen in de projecten
              Geef ze de vijf! en Erfbetreders en Levensduur, en nieuwe informatie
              uit het onderzoek, is het platform geactualiseerd. Het is ook van naam
              veranderd en heet voortaan Omdatlevensduurloont. Vanaf nu is het
              platform voor iedereen vrij beschikbaar:
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              href="https://omdatlevensduurloont.nl"
              target="_blank"
              class="wrap-text"
            >
              Bezoek het platform<br>omdatlevensduurloont.nl
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex
        sm6
        lg3
        class="registration-info"
      >
        <v-card>
          <v-card-title primary-title>
            <img src="/discussion_icon.svg">
            <div class="headline">
              Discussieplatform
            </div>
          </v-card-title>
          <v-card-text class="grow">
            Uitwisseling van kennis en ervaring tussen melkveehouders,
            gestructureerd naar specifieke thema’s rond levensduur. Dat is de
            hoofdfunctie van het discussieplatform van Geef ze de Vijf! Als
            deelnemer kunt u een lijst met kengetallen invullen waarmee het
            levenssaldo van uw veestapel wordt berekend: wat hebben je koeien
            jou opgeleverd en wat leveren ze op als de levensduur wordt
            verlengd? Je kunt je bedrijf op basis van de levensduurprestaties
            vergelijken met dat van collega’s op het platform. Als je deelneemt
            aan het platform kun je ook gebruik maken van de digitale
            handleiding Duurzaam Melkvee Management. De kosten voor het
            totaalpakket bedragen in het eerste jaar slechts €75 (excl. BTW).
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="false"
              color="extra"
              :to="{ name: 'register', params: { subscription: 'standard' } }"
              dark
            >
              {{ $t('message.register_button') }}
            </v-btn>
            <v-btn
              depressed
              disabled
            >
              {{ $t('message.coming_soon') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex
        sm6
        lg3
        class="registration-info"
      >
        <v-card>
          <v-card-title primary-title>
            <img src="/cow_head_icon.svg">
            <div class="headline">
              Project Geef ze de Vijf!
            </div>
          </v-card-title>
          <v-card-text class="grow">
            Wil je concrete stappen zetten om de levensduur te verlengen, dan
            kun je deelnemen aan het project Geef ze de Vijf! Hét project
            waarbinnen je samen met collega-melkveehouders toewerkt naar een
            veestapel met een volwassen levensduur van 5 lactaties. Een
            intensief programma voor gemotiveerde melkveehouders waarbij
            verschillende handige hulpmiddelen worden ingezet om het tot een
            succes te maken. Bij deelname kun je ook gebruik maken van de
            digitale handleiding Duurzaam Melkvee Management, deelnemen aan het
            discussieplatform en de bedrijfsvergelijking van de
            levensduurprestaties en je hebt de mogelijkheid om gerichte
            kennisvragen te stellen die beantwoord worden door specialisten.
          </v-card-text>
          <v-expansion-panel v-model="expanded[2]">
            <v-expansion-panel-content>
              <template v-slot:actions>
                <v-icon color="success">
                  $vuetify.icons.expand
                </v-icon>
              </template>
              <template v-slot:header>
                <div class="success--text">
                  Binnen het project<br>kun je kiezen voor
                </div>
              </template>
              <v-card>
                <v-card-text>
                  <ul>
                    <li>
                      Een bedrijfsspecifieke levensduuranalyse: waar liggen op
                      jouw bedrijf de mogelijkheden?
                    </li>
                    <li>
                      Gebruik van de PDCA methode voor gestructureerd en
                      doelgericht werken en ondersteuning daarbij.
                    </li>
                    <li>
                      Een bedrijfsspecifieke economische analyse: wat gaat een
                      langere levensduur je opleveren?
                    </li>
                    <li>
                      Een jaarlijks bedrijfsbezoek voor het bespreken van de
                      voortgang.
                    </li>
                  </ul>
                  Het programma van Geef ze de Vijf! kan ook in
                  studiegroepverband gevolgd worden. De kosten voor deelname
                  zijn afhankelijk van je persoonlijke wensen. Voor meer
                  informatie kun je contact met ons opnemen via
                  <a href="mailto:info@geefzedevijf.nl">info@geefzedevijf.nl</a>
                  <v-card-actions>
                    <v-btn
                      v-if="false"
                      color="success"
                      :to="{
                        name: 'register',
                        params: { subscription: 'extensive' },
                      }"
                    >
                      {{ $t('message.register_button') }}
                    </v-btn>
                    <v-btn
                      depressed
                      disabled
                    >
                      {{
                        $t('message.coming_soon')
                      }}
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card>
      </v-flex>

      <v-flex
        sm6
        lg3
        class="registration-info"
      >
        <v-card>
          <v-card-title primary-title>
            <img src="/boot_icon.svg">
            <div class="headline">
              Platform voor erfbetreders
            </div>
          </v-card-title>
          <v-card-text class="grow">
            Wil je dat je erfbetreder (dierenarts, veevoeradviseur,
            fokkerijadviseur etc.) meekijkt en discussieert, dan kan dat. We
            willen ze er graag bij betrekken. Ze kunnen dan ook gebruik maken
            van de digitale handleiding en meediscussiëren op het platform. De
            voorwaarde is wel dat het gaat om een onderbouwde, niet-commerciële,
            inhoudelijke inbreng. Voor meer informatie kun je contact met ons
            opnemen via
            <a href="mailto:info@geefzedevijf.nl">info@geefzedevijf.nl</a>. De
            kosten voor "meekijken en meedoen" voor erfbetreders bedragen €150
            euro per jaar (excl. BTW).
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="false"
              color="secondary"
              :to="{ name: 'register', params: { subscription: 'watch' } }"
              grow
            >
              {{ $t('message.register_button') }}
            </v-btn>
            <v-btn
              depressed
              disabled
            >
              {{ $t('message.coming_soon') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import ForgotPasswordDialog from '../admin/ForgotPasswordDialog'
import feathersClient from '../../feathers-client'
export default {
  components: { ForgotPasswordDialog },
  data() {
    return {
      email: '',
      password: '',
      loginError: '',
      showError: false,
      expanded: [],
      showForgotPasswordDialog: false,
    }
  },
  computed: {
    isInitialFlex() {
      return this.expanded.find((e) => e === 0) === undefined
    },
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == 'authSuccess') {
        this.$router.push({ name: 'dashboard' })
      }
    })
  },
  mounted() {
    setTimeout(() => {
      let box = document.querySelector('.registration-info > .v-card')
      let height = window.getComputedStyle(box).height
      document
        .querySelectorAll('.registration-info > .v-card')
        .forEach((e) => (e.style.minHeight = height))
    }, 500)
  },
  methods: {
    logEvent(evt) {},
    login() {
      let email = this.email
      let password = this.password
      this.$store.dispatch('login', { email, password }).catch(() => {})
    },
    sendForgotPasswordMail(email) {
      feathersClient
        .service('password-reset')
        .create({
          email: email,
        })
        .then((res) => {
          this.$store.commit(
            'showSnackbarMessage',
            'message.reset_password_link_sent'
          )
          this.showForgotPasswordDialog = false
        })
    },
  },
}
</script>
